/**
 * NotificationServiceProvider
 *
 * Registers the notification service with notistack's enqueueSnackbar.
 * This allows the notification service to be used outside React components.
 *
 * Must be placed inside SnackbarProvider in the component tree.
 */

import { useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { notificationService } from 'services/notificationService';

export const NotificationServiceProvider = ({ children }: { children: React.ReactNode }) => {
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    notificationService.register(enqueueSnackbar);
  }, [enqueueSnackbar]);

  return <>{children}</>;
};
